import * as React from 'react';
import { NavLink } from 'react-router-dom';


export interface Props {
  key: React.Key;
  organisation: any;
}

export default ({ organisation: { uuid, created_at, org_name } }: Props ) => (
    <tr>
        <td scope="row"><NavLink to={`/organisation/${uuid}`}>{org_name}</NavLink></td>
        <td>{created_at}</td>
    </tr>
);



// WEBPACK FOOTER //
// ./src/components/OrganisationListCell.tsx